<template>
    <div class="login-container">
      <div class="login-box">
        <div class="logo">
          <i class="el-icon-picture"></i>
          <span>Pet Social</span>
        </div>
  
        <el-form 
          :model="user" 
          :rules="rules" 
          ref="loginForm" 
          class="login-form"
        >
          <el-form-item prop="username">
            <el-input
              v-model="user.username"
              placeholder="请输入用户名"
              prefix-icon="el-icon-user"
            ></el-input>
          </el-form-item>
  
          <el-form-item prop="password">
            <el-input
              v-model="user.password"
              type="password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              show-password
            ></el-input>
          </el-form-item>
  
          <el-form-item class="button-group">
            <el-button
              :disabled="isDisabled"
              type="primary"
              class="login-btn"
              @click="loginUp"
              :loading="loading"
            >登录</el-button>
            <el-button
              class="cancel-btn"
              @click="goBack"
            >取消</el-button>
          </el-form-item>
          
          <div class="register-link">
            <span>没有账户？</span>
            <router-link to="/registerPage">立即注册</router-link>
          </div>
        </el-form>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: 'LoginPage',
    data() {
      return {
        loading: false,
        user: {
          username: '',
          password: ''
        },
        rules: {
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            { min: 3, max: 12, message: '长度在 3 到 12 个字符', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
          ]
        }
      }
    },
    computed:{
        isDisabled(){
          if(this.user.username.length > 0 && this.user.password.length > 0){
            return false
          }
          return true
        }
    },
    methods: {
      loginUp() {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.loading = true
            axios.post('http://www.wjyzlj.cn/pet/user/login', this.user)
              .then(response => {
                const { code, data, message } = response.data
                if (code === 500) {
                  this.$message.error(message)
                  return
                }
                if (code === 200) {
                  this.$message.success('登录成功')
                  this.handleLoginSuccess(data)
                }
              })
              .catch(err => {
                console.error(err)
                this.$message.error('登录请求失败')
              })
              .finally(() => {
                this.loading = false
              })
          }
        })
      },
      goBack() {
        this.$router.go(-1) // 返回上一页
      },
      handleLoginSuccess(data) {
        // 存储用户信息
        document.cookie = `username=${this.user.username}`
        document.cookie = `id=${data.loginId}`
        document.cookie = "isLogging=true"
      
        // 存储token
        role = data.whetherAdmin ? 'admin' : 'user'
        sessionStorage.setItem('token', data.tokenValue)
        sessionStorage.setItem('role',role)
        // 路由跳转
        const targetRoute = data.whetherAdmin ? '/adminPage' : '/mainPage'
        this.$router.push(targetRoute)
      }
    }
  }
  </script>
  
  <style scoped>
  .login-container {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('https://cdn.pixabay.com/photo/2017/09/25/13/12/dog-2785074_1280.jpg') center/cover;
  }
  
  .login-box {
    width: 400px;
    padding: 40px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  
  .logo {
    text-align: center;
    margin-bottom: 30px;
  }
  
  .logo i {
    font-size: 40px;
    color: #ff85ad;
  }
  
  .logo span {
    display: block;
    font-size: 24px;
    color: #ff85ad;
    font-weight: bold;
    margin-top: 10px;
  }
  
  .button-group {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  
  .login-btn {
    flex: 1;
    margin-right: 10px;
  }
  
  .cancel-btn {
    flex: 1;
    margin-left: 10px;
  }
  
  .register-link {
    text-align: center;
    margin-top: 20px;
    color: #666;
  }
  
  .register-link a {
    color: #409eff;
    margin-left: 5px;
  }
  
  .el-form-item {
    margin-bottom: 22px;
  }
  </style>